import React from "react";
import Skeleton from "theme/components/atoms/Skeleton";

const ProductOverview = () => (
  <div className="product-overview">
    <div className="product-overview__name">
      <Skeleton>Loading product</Skeleton>
    </div>
    <div className="product-overview__price">
      <Skeleton>xx.xx €</Skeleton>
    </div>
  </div>
);

export default ProductOverview;
